import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronLargeLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-large-left, chev left, last"><path fillRule="evenodd" clipRule="evenodd" d="M14.6333 2.10546C14.9893 2.31716 15.1063 2.77739 14.8947 3.13342L9.62256 12.0001L14.8947 20.8668C15.1063 21.2228 14.9893 21.6831 14.6333 21.8948C14.2773 22.1065 13.817 21.9895 13.6053 21.6334L8.10535 12.3834C7.96488 12.1472 7.96488 11.8531 8.10535 11.6168L13.6053 2.36681C13.817 2.01078 14.2773 1.89377 14.6333 2.10546Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronLargeLeft;
